import { render, staticRenderFns } from "./EntradasCompradas.vue?vue&type=template&id=770034b1"
import script from "./EntradasCompradas.vue?vue&type=script&lang=js"
export * from "./EntradasCompradas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports